import axios from 'axios';
import * as Config from '../../config';

const state = { };

const actions = {
    assets_videoLanding({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'assets/video-landing', {
                responseType: 'blob' // importante para recibir binario
            })
            .then(response => {
                // crear URL temporal para el video
                const videoUrl = URL.createObjectURL(response.data);
                resolve(videoUrl);
            })
            .catch(error => {
                reject(error.response);
            });
        });
    },
    assets_gifMonotributista({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'assets/gif-monotributista', {
                responseType: 'blob' // importante para recibir binario
            })
            .then(response => {
                // crear URL temporal para el video
                const videoUrl = URL.createObjectURL(response.data);
                resolve(videoUrl);
            })
            .catch(error => {
                reject(error.response);
            });
        });
    }
};

const mutations = { };

export default {
    state,
    actions,
    mutations
};
